/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_SendInputs */

const en_friends_send = /** @type {(inputs: Friends_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send suggestion`)
};

const de_friends_send = /** @type {(inputs: Friends_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschlag senden`)
};

/**
* | output |
* | --- |
* | "Send suggestion" |
*
* @param {Friends_SendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_send = /** @type {((inputs?: Friends_SendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_SendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_send(inputs)
	return en_friends_send(inputs)
});